import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { installStaleChunkRecovery } from './utils/staleChunkRecovery'
import './index.css'

installStaleChunkRecovery();

createRoot(document.getElementById("root")!).render(<App />);
